// Stable viewport height (px) matching the CSS `--vph` variable, which the
// head script sets once and updates only on width/orientation change. Using
// this instead of `window.innerHeight` keeps scroll-driven math stable while
// in-app browsers (WhatsApp/Instagram) animate their toolbar mid-scroll.
export const getVPH = () => {
  const v = parseFloat(
    getComputedStyle(document.documentElement).getPropertyValue("--vph")
  );
  return Number.isFinite(v) && v > 0 ? v : window.innerHeight;
};
